<template>
  <header class="app-header navbar">
    <b-link class="navbar-brand" to="/#/"></b-link>

    <UserContext></UserContext>
    <b-navbar-nav class="d-md-down-none">
      <b-nav-item-dropdown class="px-3" v-if="authUser.isSuperAdmin" text="Admin" right>
        <router-link tag="b-dropdown-item" class="px-3" :to="{ path: '/admin/users' }">
          Users
        </router-link>
        <router-link tag="b-dropdown-item" class="px-3" :to="{ path: '/admin/organizations' }">
          Organizations
        </router-link>
        <router-link tag="b-dropdown-item" class="px-3" :to="{ path: '/admin/groups' }">
          Groups
        </router-link>
        <router-link tag="b-dropdown-item" class="px-3" :to="{ path: '/admin/logs' }">
          Logs
        </router-link>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown ref="parentDropdown" class="px-3" text="Data" right @hide="hideParentDropdown">
        <router-link tag="b-dropdown-item" class="px-3" :to="{ path: '/statistics' }">
          Statistics
        </router-link>
        <router-link v-if="authUser.isSuperAdmin" tag="b-dropdown-item" class="px-3" :to="{ path: '/globalreport' }">
          Global Reports
        </router-link>
        <b-dropdown-item
          v-if="authUser.isSuperAdmin || isOrgManagerOrAdmin"
          tag="b-dropdown-item"
          class="px-3"
          @click="downloadUserReportsByOrg"
        >
          Download User Reports
        </b-dropdown-item>
        <b-dropdown
          v-if="isUserInLA"
          ref="nestedDropdown"
          class="header-dropdown-item px-3"
          text="Annual Data"
          dropright
          @hide="hideNestedDropdown"
          @show="isAnnualDataDropdownVisible = true"
        >
          <router-link
            v-for="year, i in annualDataYears"
            :key="i"
            tag="b-dropdown-item"
            :to="{ path: `/reviewannualdata/${year}` }"
          >
            {{ year }}
          </router-link>
        </b-dropdown>
        <!-- <router-link tag="b-dropdown-item" class="px-3" :to="{ path: '/google-maps' }">
          Map
        </router-link> -->
      </b-nav-item-dropdown>

      <b-nav-item-dropdown class="px-3" text="Help" right>
        <b-dropdown-item  class="px-3" target="_blank" href="https://share.hsforms.com/1bLyB7vWCRra3LjVUBn_qqA2gbug">
          Submit Feedback
        </b-dropdown-item>
        <b-dropdown-item  class="px-3" target="_blank" href="https://alliesagainstslavery.org/lighthouse-support/">
          Support
        </b-dropdown-item>
        <b-dropdown-item class="px-3" target="_blank" href="https://lighthouse-pdf-images.s3-us-west-2.amazonaws.com/WCC.CSE-IT.2.0.pdf">
          View CSE-IT Form
        </b-dropdown-item>
        <b-dropdown-item v-if="isUserInLA" class="px-3" target="_blank" href="https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/LT+Identification+Tool+FINAL.pdf">
          View Labor Screening
        </b-dropdown-item>
        <b-dropdown-item v-if="isUserInLA" class="px-3" target="_blank" href="https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/LT+Identification+Tool+Supplementary+Guide+FINAL.pdf">
          Labor Screening Guide
        </b-dropdown-item>
        <b-dropdown-item v-if="isUserInLA" class="px-3" target="_blank" href="https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/Louisiana.Sex.Trafficking.Tool_Final.Draft.2.pdf">
          View LA Sex Trafficking Tool
        </b-dropdown-item>
        <b-dropdown-item v-if="isUserInLA" class="px-3" target="_blank" href="https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/Supplementary.User.Guide_LSTTpdf.1.pdf">
          LA Sex Trafficking Tool User Guide
        </b-dropdown-item>
        <!-- <b-dropdown-item  class="px-3" @click.prevent="browserRefresh()">
          Update Application
        </b-dropdown-item> -->
      </b-nav-item-dropdown>

      <b-nav-item class="px-3" v-if="$auth.ready()" @click="logout">Log Out</b-nav-item>
    </b-navbar-nav>
  </header>
</template>
<script>
  import { mapGetters } from 'vuex'
  import HeaderDropdownTasks from './HeaderDropdownTasks.vue'
  import UserContext from '@/components/Header/UserContext.vue'
  import userStateMixin from '@/mixins/userState.js'
  import annualDataMixin from '@/mixins/annualData.js'
  import userPermissionMixin from '@/mixins/userPermission.js'
  import jsonToCsvMixin from '@/mixins/jsonToCsv.js'
  import { USER_REPORT_HEADER, USER_REPORT_HEADER_LA } from '@/helpers/enums.js'

  export default {
    name: 'headernav',
    mixins: [userStateMixin, annualDataMixin, userPermissionMixin, jsonToCsvMixin],
    components: {
      HeaderDropdownTasks,
      UserContext
    },

    data: function () {
      return {
        showOrganizationModal: false,
        userOrganizationId: 0,
        authUser: this.$auth.user(),
        isAnnualDataDropdownVisible: false
      }
    },

    computed: {
      ...mapGetters({
        userReportsByOrg: 'getUserReportsByOrg'
      })
    },

    mounted () {
      const nestedDropdown = this.$refs.nestedDropdown
      if (nestedDropdown) {
        const btn = nestedDropdown.$el.getElementsByClassName('dropdown-toggle')[0]
        if (btn && btn.classList) {
          btn.classList.add('dropdown-item')
          btn.classList.remove('dropdown-toggle')
        }
      }
    },

    methods: {
      async downloadUserReportsByOrg () {
        await this.getUserReportsByOrg()
        const headers = this.isUserInLA ? USER_REPORT_HEADER_LA : USER_REPORT_HEADER
        const csv = this.jsonToCsv(this.userReportsByOrg, headers)
        this.downloadCsv(csv, 'Lighthouse User Reports.csv')
      },
      getUserReportsByOrg () {
        return this.$store.dispatch('getUserReportsByOrg')
      },
      browserRefresh () {
        window.location.reload(true)
      },
      logout: function () {
        this.$store.commit('RESET_USER_CONTEXT')
        this.$store.resetState()

        this.$auth.logout({
          body: this.$auth.user(),
          success: function () {},
          error: function () {},
          redirect: '/login'
        })
      },

      hideParentDropdown (e) {
        if (this.isAnnualDataDropdownVisible) {
          e.preventDefault()
        }
      },

      hideNestedDropdown () {
        this.isAnnualDataDropdownVisible = false
        if (this.$refs.parentDropdown) {
          this.$refs.parentDropdown.hide()
        }
      }
    }
  }
</script>

<style>
.header-dropdown-item .dropdown-item {
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Header/Header.vue